/**
 * Toggles the mobile menu for EV hub
 */
const toggleMenu = () => {
    const evMenuToggleTrigger = $(".js_toggleEvMenu");

    if (evMenuToggleTrigger.length > 0) {
        evMenuToggleTrigger.click(function() {
            $(this).toggleClass('toggleEvMenu__triggerEvMenu--active')
            $(this).parent().next().stop().slideToggle();
        });
    }
}

/**
 * Close the toggle menu if on zapmap subpage and
 */
const closeMenuFromZapMapLink = () => {
    const zapMapLink = $('.js_zapMapTabTrigger')

    if (zapMapLink.length) {
        zapMapLink.on('click', function () {
            // Are we on the page with zapmap tabs
            const zapMapsTabsEl = document.querySelector('.js_evHubTabs--zapMap')

            if (!zapMapsTabsEl) {
                return
            }

            const evMenuToggleTrigger = $(".js_toggleEvMenu");

            if (!evMenuToggleTrigger) {
                return;
            }

            if (matchesMediaQuery(1151)) {
                return;
            }

            evMenuToggleTrigger.click()
        })
    }

}

$(document).ready(function () {
    toggleMenu()
    closeMenuFromZapMapLink()
})